import React, { useEffect, useRef } from 'react';

// This is a hacky solution to make the invite people drawer works in Jira with Issue Modal as there is no systematic way to change the z-index of the drawer
const ZIndexSetter = () => {
	const ref = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (ref.current) {
			const portalElement: HTMLElement | null =
				ref.current.closest && ref.current.closest('.atlaskit-portal');
			if (portalElement) {
				// we set it to 550 because we want it to stay above the modal, and below flag, spotlight and tooltip
				// directly setting the style property is the safer option than setAttribute()
				// because we don't know what other possible style properties could be
				(portalElement as any).style['z-index'] = 550;
			}
		}
	}, []);

	return <div ref={ref} />;
};

export default ZIndexSetter;
